import { Button, Modal } from 'react-bootstrap'

export default function CompanyInfoModal({
  companyName,
  info,
  closeModal,
  isModalVisible,
}) {
  return (
    <Modal show={isModalVisible} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>{companyName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{info}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Zatvori
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
